import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleAfteDispensedStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if (
    ![ROLE.Admin, ROLE.Pharmacist].includes((groups as string[])[0] as ROLE)
  ) {
    return allOrderStatus.filter((e) =>
      [
        OrderStatusCode.READY_FOR_SCAN,
        OrderStatusCode.CANCELLATION_REQUEST,
        OrderStatusCode.CANCELLED,
        OrderStatusCode.PAUSED,
        OrderStatusCode.AWAITING_PAYMENT,
      ].includes(e?.id),
    );
  } else {
    return allOrderStatus.filter((e) => commonAdminStatuses.includes(e?.id));
  }
};
